module.exports = __webpack_public_path__ + "static/media/sheep.7875824b.svg";